// 从playground或者从xy注入 保证uicore内部无敏感信息
export const devDoc = {
  designerMock: '',
  devComponent: '',
  cssInlineAdvanced: '',
  ucToggleBreakpoint: ''
};